import React, { useState, useEffect } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import styled from 'styled-components';
import { navDelay, loaderDelay } from '@utils';
import { usePrefersReducedMotion } from '@hooks';
import { TextParticles } from 'react-text-particles';

const StyledHeroSection = styled.section`
  ${({ theme }) => theme.mixins.flexCenter};
  flex-direction: column;
  align-items: flex-start;
  min-height: 100vh;
  padding: 0;

  @media (max-width: 480px) and (min-height: 700px) {
    padding-bottom: 10vh;
  }

  h1 {
    margin: 0 0 30px 4px;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: clamp(var(--fz-sm), 5vw, var(--fz-md));
    font-weight: 400;

    @media (max-width: 480px) {
      margin: 0 0 20px 2px;
    }
  }

  h3 {
    margin-top: 10px;
    color: var(--slate);
    line-height: 0.9;
  }

  p {
    margin: 20px 0 0;
    max-width: 540px;
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
  }

  .padding-above {
    padding-bottom: 120px;
  }
`;

const Hero = () => {
  const [isMounted, setIsMounted] = useState(false);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    const timeout = setTimeout(() => setIsMounted(true), navDelay);
    return () => clearTimeout(timeout);
  }, []);

  const one = <h1 className="select-none">Hi, I'm</h1>;
  const canvas = { bg: '#161c1e' };

  const two = (
    <h2 className="big-heading glitching" data-text="Mehdi Tassoumt">
      Mehdi Tassoumt
    </h2>
  );
  const three = <h4 className="big-heading select-none">I build things</h4>;
  const four = (
    <>
      <p className="padding-above select-none">
        🝨 🝥 Ⲷ Fullstack software engineer, well versed in cybersecurity, devops, web dev and
        blockchains. Occasionally designing peculiar visualisations, immersive web experiences, and
        arty coding experiments ⳬ 🝩 🝦
      </p>
    </>
  );
  const five = (
    <a
      className="email-link"
      href="https://www.linkedin.com/in/mehditassoumt/"
      target="_blank"
      rel="noreferrer"
    >
      Connect on LinkedIn
    </a>
  );

  const six = (
    <div className="button-wrapper">
      <a href="https://www.linkedin.com/in/mehditassoumt/">
        <svg height="60" xmlns="http://www.w3.org/2000/svg">
          <rect className="button-wrapper__shape" height="60" width="100%" rx="0" />
        </svg>
        <div className="button-wrapper__text">Connect on LinkedIn</div>
      </a>
    </div>
  );

  const items = [one, two, four, six];

  return (
    <StyledHeroSection>
      {prefersReducedMotion ? (
        <>
          {items.map((item, i) => (
            <div key={i}>{item}</div>
          ))}
        </>
      ) : (
        <TransitionGroup component={null}>
          {isMounted &&
            items.map((item, i) => (
              <CSSTransition key={i} classNames="fadeup" timeout={loaderDelay}>
                <div style={{ transitionDelay: `${i + 1}00ms` }}>{item}</div>
              </CSSTransition>
            ))}
        </TransitionGroup>
      )}
    </StyledHeroSection>
  );
};

export default Hero;
